<app-row-cards-touch
  [customerName]="!isReview && vm.customerName"
  [customerNumber]="!isReview && vm.customerNumber"
  [subtitle]="
    !isReview && vm.hasSecondaryTransaction
      ? translatorText.invoice + ' #' + vm?.secondaryTransactionNumber
      : ''
  "
  [status]="!isReview && vm.status"
  [hasLink]="!!vm.isr?.docID"
  [linkText]="'#' + vm?.transactionNumber"
  [selectable]="selectable"
  [additionalInfo]="vm?.transactionTypeString"
  [color]="isReview ? 'gray' : vm.statusColor"
  [selected]="vm.selected"
  [icon]="showButtons && !shouldHaveEditableAmount ? 'ellipsis-vertical' : ''"
  [edgeAction]="
    (showEditAmount ? 'i18n.payments.transactionRow.editAmount' : '')
      | translate
  "
  [columnsData]="columns"
  [showVoidColumns]="!isMobile"
  (iconClick)="onMoreOptionClick()"
  (linkClick)="onViewInvoiceClick()"
  (checkboxChange)="onTransactionRowClick()"
  (edgeActionClick)="onEditAmountClick()"
></app-row-cards-touch>
